import React, {
    ReactElement,
} from "react";
import useWrappedRefWithWarning from "react-bootstrap/useWrappedRefWithWarning";
// eslint-disable-next-line import/no-extraneous-dependencies
import useMergedRefs from "@restart/hooks/useMergedRefs";
// eslint-disable-next-line import/no-extraneous-dependencies
import { useDropdownToggle } from "@restart/ui/DropdownToggle";

import classNames from "classnames";
import Button, { ButtonProps } from "../button/Button";
import { LoggingHandler } from "../../../contexts/logging/LoggingContext";

export interface ToggleProps extends ButtonProps {
    split?: "left" | "right";
    displayAs?: "default" | "select";
    shouldStopPropagation?: boolean;
}

const Toggle = React.forwardRef((
    args: ToggleProps,
    ref: React.ForwardedRef<HTMLButtonElement>,
): ReactElement => {
    const {
        className,
        split,
        displayAs,
        metricPath,
        onClick,
        shouldStopPropagation,
        ...rest
    } = args;

    const [toggleProps] = useDropdownToggle();

    toggleProps.ref = useMergedRefs(
        toggleProps.ref,
        useWrappedRefWithWarning(ref, "DropdownToggle"),
    );

    const clickHander = onClick ?? toggleProps.onClick;

    return (
        <Button
            data-bs-display="static"
            className={classNames(
                className,
                "dropdown-toggle",
                split ? `dropdown-split-${split}` : "",
                `dropdown-toggle-${displayAs}`,
            )}
            {...toggleProps}
            {...rest}
            onClick={(...clickArgs) => {
                if (metricPath && !toggleProps["aria-expanded"]) {
                    LoggingHandler.instance.metric(metricPath);
                }
                if (shouldStopPropagation) {
                    clickArgs[0].preventDefault();
                }
                clickHander?.(...clickArgs);
            }}
        />
    );
});

Toggle.defaultProps = {
    className: "",
    displayAs: "default",
    split: undefined,
};

export default Toggle;
